import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import {ApAlertService, ApBaseComponent, ApDatePickerValue} from 'webcommon/core-ui';
import { FindControlIdService } from 'webcommon/legacy-common';
import {
  ApCustomDateRange,
  FindControlAdditionalSearchParametersDto,
  FindControlAdditionalSearchParametersType,
  FPAppointmentsSearchDto,
  FPAppointmentsSearchResultDto,
} from 'webcommon/shared';
import { FpAppointmentsRepository } from 'webcommon/webapi';

@Component({
  selector: 'fp-appointments',
  styleUrls: ['./fp-appointments.component.less'],
  templateUrl: './fp-appointments.component.html',
})
export class FPAppointmentsComponent extends ApBaseComponent implements OnInit {
  @Input() baseId: string;

  @ViewChild('form', { static: true }) readonly form: NgForm;

  Id: string;
  searching = false;

  serviceSiteSelected: string | null = null;
  patientProgramSelected: string[] = [];
  timeSpanSelected: string | null = null;

  firstName = '';
  lastName = '';
  birthDate: ApDatePickerValue = undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;

  hasSearchFilters = false;
  hasSearched = false;

  searchResult: FPAppointmentsSearchResultDto[] | null;

  inputNames = {
    birthdate: 'birthdate',
    firstname: 'firstname',
    lastname: 'lastname',
  };

  public timeframeAdditionalSearchParams: FindControlAdditionalSearchParametersDto =
  {
    Type: FindControlAdditionalSearchParametersType.Standard,
    AdditionalSearchParameters:
    [
      {
        ColumnName: 'Name',
        Negate: true,
        Value: '',
      },
    ],
  };

  searchError = false;

  constructor(
    public findControlIdService: FindControlIdService,
    private appointmentsRepository: FpAppointmentsRepository,
    private alertService: ApAlertService,
  ) {
      super();
  }

  ngOnInit() {
    this.loading = true;
    this.setId();
    this.load();
  }

  load() {
    this.loading = false;
  }

  onClickSearch(): void {
    this.hasSearched = true;
    if (!(this.firstName
        || this.lastName
        || this.birthDate
        || this.serviceSiteSelected
        || this.patientProgramSelected.length
        || this.timeSpanSelected)
    ) {
      this.hasSearchFilters = false;
      return;
    }
    this.hasSearchFilters = true;
    this.searching = true;

    const searchDto: FPAppointmentsSearchDto = {
      DateOfBirth: this.birthDate,
      EndDate: this.endDate,
      FirstName: this.firstName,
      LastName: this.lastName,
      ProgramIds: this.patientProgramSelected,
      ServiceSiteId: this.serviceSiteSelected || undefined,
      StartDate: this.startDate,
      TimespanId: this.timeSpanSelected || undefined,
    };

    this.appointmentsRepository.getAppointmentForPatient(searchDto).pipe(
      finalize(() => this.onSearchComplete()),
      this.takeUntilDestroy(),
    ).subscribe(
      (result) => this.onSearchSuccess(result),
      () => this.onSearchError(),
    );
  }

  updateLastName(value: string): void {
    const control = this.form.controls[this.inputNames.lastname];

    control.setValue(value);
    control.markAsDirty();
  }

  updateFirstName(value: string): void {
    const control = this.form.controls[this.inputNames.firstname];

    control.setValue(value);
    control.markAsDirty();
  }

  updateBirthDate(value: string): void {
    const date = new Date(value);
    const control = this.form.controls[this.inputNames.birthdate];

    control.setValue(date);
    control.markAsDirty();
  }

  timespanChanged() {
    this.startDate = undefined;
    this.endDate = undefined;
  }

  dateRangeChanged(apCustomDateRange: ApCustomDateRange) {
    this.startDate = apCustomDateRange.StartDate;
    this.endDate = apCustomDateRange.EndDate;
  }

  private onSearchSuccess(result: FPAppointmentsSearchResultDto[]) {
    this.searchResult = result;
  }

  private onSearchError() {
    this.alert('An error has occurred and the list of patient appointments could not be displayed.');
    this.searchError = true;
    this.searchResult = null;
  }

  private onSearchComplete() {
    this.searching = false;
  }

  private setId() {
    this.Id = `${this.baseId}-appointments`;
  }

  private alert(text: string) {
    this.alertService.error(text);
  }
}
